import React, { Component } from "react";

const defaultProps = {
  transitionTime: 1000,
  timingFunction: "ease",
  initialBlur: 1
};
class ProgressiveImage extends Component {
  constructor(props) {
    super(props);
    const { src, preview, darken } = this.props;
    const initialBlur = defaultProps.initialBlur;
    this.state = {
      src: preview,
      blur: initialBlur,
      darken: darken || "0.5"
    };
  }
  fetchImg = src => {
    return new Promise(resolve => {
      const image = new Image();
      image.src = src;
      image.addEventListener("load", () => resolve(src), false);
    });
  };
  componentDidMount = () => {
    this.fetchImg(this.props.src).then(srcDataURI =>
      this.setState({ src: srcDataURI, blur: 0 })
    );
  };
  render() {
    const { src, blur, darken } = this.state;
    const { transitionTime, timingFunction, styles } = this.props;
    return (
      <div
        style={{
          background: `linear-gradient( rgba(0, 0, 0, ${darken}), rgba(0, 0, 0, ${darken}) ), url(${src}) no-repeat top / cover`,
          backgroundColor:
            "linear-gradient( rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25) )",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "50% 100%",
          backgroundSize: "cover",
          textAlign: "center",
          ...styles
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default ProgressiveImage;



// WEBPACK FOOTER //
// ./src/components/progressiveImage.jsx